<template>
    <div ref="btn">
        <button
            @click="makePayment"
            v-observe-visibility="visibilityChanged"
            class="buy-button buy-button--has-payment-method"
            :class="classes"
            data-test="immediate-payment-button">
            <slot></slot>
        </button>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { bannerAnim, topBarAnim } from '../../../animations';

export default {
    props: {
        applePay: {
            required: true,
            type: Boolean,
        },
        paymentType: {
            required: true,
            type: String,
            validator: (value) => {
                return ['now', 'plan'].indexOf(value) !== -1;
            },
        },
        classes: {
            required: false,
            type: String,
            default: '',
        },
        isLifetimeUpdates: {
            required: false,
            type: Boolean,
            default: false,
        },
    },

    data: function () {
        return {
            salesButtonSeenFirstTime: false,
        };
    },

    computed: mapState(['applePayAvailable', 'defaultPaymentMethod', 'paymentMethodToken']),

    methods: {
        makePayment(event) {
            if (!this.paymentMethodToken) {
                setTimeout(this.makePayment, 10);
                return;
            }
            const banner = document.querySelector('.banner');

            banner?.classList.remove('banner--show');

            this.$store.commit('setPaymentType', this.paymentType);

            if (this.isLifetimeUpdates) this.$store.commit('setProcessingCheckout', true);

            this.tracker.firePixelEvent('upsell_buy_button_is_clicked');

            window.ipse.dispatch({
                action: this.isLifetimeUpdates ? 'purchase_lifetime_updates_clicked' : 'immediate_payment_clicked',
                data_event: {
                    section_name:
                        event.srcElement.closest('[data-track-name]')?.getAttribute('data-track-name') ?? 'unknown',
                    payment_method: this.defaultPaymentMethod,
                },
            });

            if (this.defaultPaymentMethod === 'apple-pay') {
                if (this.applePayAvailable && this.paymentType === 'now') {
                    this.eventBus.emit('MAKE_IMMEDIATE_APPLE_PAY_PAYMENT');
                } else {
                    if (this.isLifetimeUpdates) this.$store.commit('setProcessingCheckout', false);
                    this.$store.commit('openCheckout', {
                        step: 2,
                    });
                }
            } else if (this.defaultPaymentMethod === 'credit-card') {
                this.$store.commit('increaseImmediatePaymentAttempts');
                if (!this.isLifetimeUpdates) this.$store.commit('setProcessingImmediatePayment', true);
                this.eventBus.emit('MAKE_IMMEDIATE_CREDIT_CARD_PAYMENT', this.paymentMethodToken);
            } else {
                this.$store.commit('increaseImmediatePaymentAttempts');
                this.$store.dispatch('immediatePayment', this.paymentMethodToken);
            }
        },

        visibilityChanged(isVisible) {
            if (isVisible) {
                this.eventBus.emit('SETUP_BRAINTREE_CLIENT');
                this.tracker.firePixelEvent('first_buy_buttons_are_seen');
                this.salesButtonSeenFirstTime = true;
            } else {
                if (this.salesButtonSeenFirstTime) {
                    this.$store.commit('salesButtonSeen');
                    /*
                     * Call a helper function from question-form.js
                     * to handle question button appearence when floating sales button is visible
                     */
                    floatingSalesButtonVisible();
                }
            }
        },

        observeButton() {
            const btn = this.$refs.btn.querySelector('.buy-button:not(.banner__cta)');
            const noBanner = !btn || (window.App.isIosView && !window.App.isIosPwa);

            if (noBanner) return;

            bannerAnim(btn);
        },
    },
    mounted() {
        this.observeButton();
        topBarAnim();
    },
};
</script>
